import { createSlice } from '@reduxjs/toolkit';

// project imports
import rackAxiosServices from 'utils/rackAxiosServices';
import axios from 'utils/axios';

import { dispatch } from '../index';

const initialState = {
  error: null,
  scheduleAs: [],
  scheduleA: {},
  agreement: {},
  productOrderForm: {},
  pricing: {},
  isLoading: false,
};

const scheduleA = createSlice({
  name: 'scheduleA',
  initialState,
  reducers: {
    // HAS ERROR
    hasError(state, action) {
      state.error = action.payload.error;
    },
    // ADD scheduleA  Information
    addScheduleAInformationSuccess(state, action) {
      state.scheduleA = action.payload.scheduleAInfo;
    },
    // UPDATE scheduleA  Information
    updateScheduleAInformationSuccess(state, action) {
      state.scheduleA = action.payload.updateInformation;
    },
    deleteScheduleASuccess: (state, action) => {
      const id = action.payload;
      // eslint-disable-next-line
      state.scheduleAs = state.scheduleAs.filter(scheduleA => scheduleA.scheduleAUuid !== id);
      // eslint-disable-next-line
      state.scheduleA = {};
    },

    getScheduleASuccess(state, action) {
      state.scheduleA = action.payload;
    },
    getScheduleAsSuccess(state, action) {
      state.scheduleAs = action.payload;
    },
    clearCurrentScheduleAData(state, action) {
      state.scheduleA = {};
    },
    getProductOrderFormSuccess(state, action) {
      state.productOrderForm = action.payload;
    },
    getAgreementSuccess(state, action) {
      state.agreement = action.payload;
    },
    getPricingSuccess(state, action) {
      state.pricing = action.payload;
    },
    
    setLoadingScheduleA(state, action) {
      state.isLoading = action.payload;
    }
  }
});

// Reducer
export default scheduleA.reducer;
export const { clearCurrentscheduleAData } = scheduleA.actions;
// advisor workbook functions
export function saveScheduleAInformation(scheduleAInfo) {
  return async () => {
    try {
      await rackAxiosServices.post(process.env.REACT_APP_SCHEDULE_A_API_URL, { ...scheduleAInfo });
      dispatch(scheduleA.actions.addScheduleAInformationSuccess(scheduleAInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(scheduleA.actions.hasError(axiosError));
      console.log('saving error', axiosError);

    }
  };
}

export function updateScheduleAInformation(scheduleAInfo) {

  return async () => {
    try {
      await rackAxiosServices.put(process.env.REACT_APP_SCHEDULE_A_API_URL, { ...scheduleAInfo });
      dispatch(scheduleA.actions.updateScheduleAInformationSuccess(scheduleAInfo));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(scheduleA.actions.hasError(axiosError));
      console.log('axios error', axiosError)
      console.log(`Update Error from axios call ${JSON.stringify(error.response.data)}`);

    }
  };
}
export function deleteScheduleA(id) {
  return async (dispatch) => {
    try {
      const url = process.env.REACT_APP_SCHEDULE_A_API_URL;
      // eslint-disable-next-line prefer-template
      const response = await rackAxiosServices.delete(url + "/object/" + id);
      dispatch(scheduleA.actions.deleteScheduleASuccess(response.data));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      dispatch(scheduleA.actions.hasError(axiosError));
      console.log(error);
    }
  };
}

export function getScheduleA(scheduleAUuid) {
  return async () => {
    try {
      dispatch(scheduleA.actions.setLoadingScheduleA(true));
      const url = process.env.REACT_APP_SCHEDULE_A_API_URL + '/' + scheduleAUuid;
      const response = await rackAxiosServices.get(url);
      dispatch(scheduleA.actions.getScheduleASuccess(response.data[0]));
      dispatch(scheduleA.actions.setLoadingScheduleA(false));
    } catch (error) {

      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      console.log(`Error from axios call ${JSON.stringify(axiosError)}`);

      dispatch(scheduleA.actions.hasError(axiosError));
    }
  };
}

export function getScheduleAsByGrowerId(growerUuid) {
  return async () => {
    try {
      dispatch(scheduleA.actions.setLoadingScheduleA(true));
      const url = process.env.REACT_APP_SCHEDULE_A_API_URL + '/grower/' + growerUuid;
      const response = await rackAxiosServices.get(url);

      dispatch(scheduleA.actions.getScheduleAsSuccess(response.data));
      dispatch(scheduleA.actions.setLoadingScheduleA(false));
    } catch (error) {
      const axiosError = {
        message: error.message,
        status: error.status,
        code: error.code
      };
      console.log(`Error from axios call ${JSON.stringify(axiosError)}`);

      dispatch(scheduleA.actions.hasError(axiosError));
      console.log(`Error from axios call ${JSON.stringify(error.response.data)}`);

    }
  };
}

export function getProductOrderFormValues(scheduleAFormValues) {
  return async () => {
    try {
      dispatch(scheduleA.actions.setLoadingScheduleA(true));
      const url = process.env.REACT_APP_BUS_LOGIC_URL + '/schedule-a-calculations';
      const response = await rackAxiosServices.post(url, scheduleAFormValues);

      dispatch(scheduleA.actions.getProductOrderFormSuccess(response.data));
      dispatch(scheduleA.actions.setLoadingScheduleA(false));

    } catch (error) {

      dispatch(scheduleA.actions.hasError(error.response.data));
      console.log(`Error from axios call ${JSON.stringify(error.response.data)}`);

    }
  };
}

export function uploadAgreement(agreementData) {
  return async () => {
    try {
      const url = process.env.REACT_APP_SCHEDULE_A_API_URL + '/agreement';
      const response = await rackAxiosServices.post(url, {scheduleAUuid: agreementData.scheduleAUuid});
      const presignedS3Url = response.data;
      console.log(presignedS3Url);

      const axiosResponse = await axios.put(presignedS3Url.data, {
        data: agreementData.data,
      });

      // dispatch(scheduleA.actions.getAgreementSuccess(response.data));
    } catch (error) {
      console.log(error);
      dispatch(scheduleA.actions.hasError(error.response.data));
      console.log(`Error from axios call ${JSON.stringify(error.response.data)}`);

    }
  };
}

export function updatePricing(pricingData) {
  return async () => {
    try {
      const formattedPricing = {
        agronomyServices: {
          perAcre: {
            inSeasonTissuePrice: pricingData.inSeasonTissuePrice,
            soilTest3ZonePrice: pricingData.soilTest3ZonePrice,
            soilTestBasicPrice: pricingData.soilTestBasicPrice,
            vrMapCreationPrice: pricingData.vrMapCreationPrice,
          },
          perFarm: {
            fpaPrice: pricingData.fpaPrice,
          },
          perOrder: {
            addTestPrice: pricingData.addTestPrice,
            addTissuePrice: pricingData.addTissuePrice,
            agrianSubscriptionPrice: pricingData.agrianSubscriptionPrice,
            seedPlanPrice: pricingData.seedPlanPrice,
            seedTestPrice: pricingData.seedTestPrice,
          }
        },
        fixedCosts: {
          addOnMargin: pricingData.addOnMargin,
          fixedMargin: pricingData.fixedMargin,
          seedTesting: pricingData.seedTesting,
          threeZoneSoil: pricingData.threeZoneSoil,
          threeZoneTissue: pricingData.threeZoneTissue,
        },
        laborCosts: {
          agronomistFixedCostPerHour: pricingData.agronomistFixedCostPerHour,
          agronomistMiscCostPerHour: pricingData.agronomistMiscCostPerHour,
          agronomistSplitCostPerHour: pricingData.agronomistSplitCostPerHour,
          seedTestingHours: pricingData.seedTestingHours,
          threeZoneSoilSamplingHours: pricingData.threeZoneSoilSamplingHours,
          threeZoneTissueSamplingHours: pricingData.threeZoneTissueSamplingHours,
        },
        lowerBounds: {
          corePricePerAcreLowerBound: pricingData.corePricePerAcreLowerBound,
          soilAddOnPricePerAcreLowerBound: pricingData.soilAddOnPricePerAcreLowerBound,
          tissueAddOnPricePerAcreLowerBound: pricingData.tissueAddOnPricePerAcreLowerBound,
        },
        prescriptionPricePerAcre: pricingData.prescriptionPricePerAcre,
        scouting: {
          biweeklyPPA: pricingData.biweeklyPPA,
          monthlyPPA: pricingData.monthlyPPA,
          weeklyPPA: pricingData.weeklyPPA,
        },
        pricePerAcre: pricingData.pricePerAcre,
      };
      const url = process.env.REACT_APP_BUS_LOGIC_URL + '/pricing';
      const response = await rackAxiosServices.put(url, formattedPricing);
    } catch (error) {

      dispatch(scheduleA.actions.hasError(error.response.data));
      console.log(`Error from axios call ${JSON.stringify(error.response.data)}`);

    }
  };
}

export function getPricing() {
  return async () => {
    try {
      const url = process.env.REACT_APP_BUS_LOGIC_URL + '/pricing';
      const response = await rackAxiosServices.get(url);
      dispatch(scheduleA.actions.getPricingSuccess(response.data));
    } catch (error) {

      dispatch(scheduleA.actions.hasError(error));
      console.log(`Error from axios call ${JSON.stringify(error)}`);

    }
  };
}